import { TECH } from "~/data/tech";

import "./TechMarquee.scss";

export default function TechMarquee() {
  return (
    <section className="ss-marquee" aria-label="Technologies we teach">
      <div className="ss-marquee__track">
        {/* Two identical runs: the animation translates by -50%, so the second
            run is what's on screen when the first wraps around. */}
        {[0, 1].map((run) => (
          <ul
            key={run}
            className="ss-marquee__run"
            aria-hidden={run === 1 ? true : undefined}
          >
            {TECH.map((name) => (
              <li key={name} className="ss-marquee__item">
                {name}
              </li>
            ))}
          </ul>
        ))}
      </div>
    </section>
  );
}
